import React from 'react';
import Box from '@mui/material/Box';
import _omitBy from 'lodash/omitBy';
import _isEmpty from 'lodash/isEmpty';
import { PAYMENT_TYPE_CARD } from '../../../../../controllers/donations_controller';

export default function PaymentFeeDisclaimer({
  paymentMethod,
  paymentType,
  hideCardFee,
  disclaimerHtml,
}) {
  if (!paymentMethod) {
    return null;
  }

  if (paymentMethod.fee === '$0') {
    return null;
  }

  if (paymentType === PAYMENT_TYPE_CARD && hideCardFee) {
    return null;
  }

  const { cssStyle } = paymentMethod.disclaimer;
  const styles = cssStyle ? _omitBy(cssStyle, _isEmpty) : {};

  return (
    <Box
      aria-label="fee disclaimer"
      sx={{
        fontSize: 12,
        color: '#bdbdbd',
        mt: 1,
        ...styles,
      }}
      dangerouslySetInnerHTML={{ __html: disclaimerHtml }}
    />
  );
}
